import * as React from 'react';
import { SVGProps } from 'react';

const IconRevertSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.657 2.282a5 5 0 1 1-1.225 5.752l.913-.407a4 4 0 1 0 .951-4.575L4.5 4.5.5 5l1.09-4 1.067 1.282z" />
  </svg>
);
export default IconRevertSizeXs;
